import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { connect } from 'react-redux';
import { fetchComparisonData } from 'app/store/api/glowforge-store-api';

class ComparisonData extends PureComponent {
  state = {};
  componentDidMount() {
    if (!this.props.comparisonData) {
      this.props.fetchComparisonData();
    }
  }
  render() {
    return this.props.children(this.props);
  }
}

ComparisonData.propTypes = {
  fetchComparisonData: PropTypes.func.isRequired,
  comparisonData: PropTypes.object, // eslint-disable-line
  children: PropTypes.func.isRequired,
};

ComparisonData.defaultProps = {
  comparisonData: null,
};


const mapStateToProps = state => ({
  comparisonData: _.get(state, 'glowforgeStore.comparisonData.fields'),
  products: _.get(state, 'glowforgeStore.products'),
});

const mapDispatchToProps = dispatch => ({
  fetchComparisonData: () => dispatch(fetchComparisonData()),
});

const ComparisonDataContainer = connect(
  mapStateToProps, mapDispatchToProps,
)(ComparisonData);

export default ComparisonDataContainer;



// WEBPACK FOOTER //
// ./app/store/components/glowforge/comparison-data-container.jsx